import React from "react";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";
// Main component for DTN Deployment for Agri-Contract Manufacturers
export default function ForAgriEntreprenuer() {
  return (
    <>
      {/* Banner section */}
      <AgribusinessStack
        classname="agriEntrepreneur-bg"
        level1="System Integrator"
        level2="Agribusiness"
        level3="Agri-Contract Manufacturer"
      />

      {/* Section representing DTN deployment for agri-contract manufacturers */}
      <SolutionEcosystem
        title="DTN Deployment for Agri-Contract Manufacturer"
        type="CM"
        bodycopy="CMN is a type of DTN network where agri-Contract Manufacturer can join to monetize unutilized manufacturing capacity."
      />
    </>
  );
}

